/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var AppsIllustrationEditHomeIcon = createIcon("AppsIllustrationEditHomeIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0v80h80V0Z",
    fill: "#E1F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5.5H.5v79h79V.5Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 29H8a1 1 0 00-1 1v21a1 1 0 001 1h19a1 1 0 001-1V30a1 1 0 00-1-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 29.5h-18a1 1 0 00-1 1v20a1 1 0 001 1h18a1 1 0 001-1v-20a1 1 0 00-1-1Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 47.5h19",
    stroke: "#171717",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 29H31a1 1 0 00-1 1v21a1 1 0 001 1h19a1 1 0 001-1V30a1 1 0 00-1-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 29.5h-18a1 1 0 00-1 1v20a1 1 0 001 1h18a1 1 0 001-1v-20a1 1 0 00-1-1Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 47.5h19",
    stroke: "#171717",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 29H54a1 1 0 00-1 1v21a1 1 0 001 1h19a1 1 0 001-1V30a1 1 0 00-1-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 29.5h-18a1 1 0 00-1 1v20a1 1 0 001 1h18a1 1 0 001-1v-20a1 1 0 00-1-1Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 47.5h19",
    stroke: "#171717",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 50.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 34h-7v7h7v-7Zm23 0h-7v7h7v-7Zm23 0h-7v7h7v-7Z",
    fill: "#C8C8C8"
  }));
}, {});